import React, { Component } from 'react';
import { Redirect, Switch, Link, BrowserRouter, Route } from 'react-router-dom'
import Auth from './Auth';
import history from '../history';
import axios from 'axios';
import Autocomplete from 'react-autocomplete';
import jquery from 'jquery';
import * as extra from '../extra';


export default class LibrStat extends React.Component {

    constructor(props) {
        super(props);

        this.inputFio = this.inputFio.bind(this);
        this.submit = this.submit.bind(this);
        this.getPosition = this.getPosition.bind(this);
        this.editPps = this.editPps.bind(this);


        this.state = {
            fio: '',
            listPpsIsLoaded: false,
            listPps: [],
            count: 0,
        };
    };

    inputFio(e){
        this.setState({
            fio: e.target.value
        })
    }

    submit(){

    }

    getPosition(){

    }

    editPps(pps){
        this.props.editPps(pps);
        //window.location.href = "/";
        //history.push('/libr');
        let url = "/#/libr";
        window.location.href = url;
    }

    componentWillMount(){
      //получение списка ФИО
      let list = extra.api('getLibrStatistic', '');
      list = JSON.parse(list);
      list.pop();

      this.setState({
          listPpsIsLoaded: true,
          listPps: list,
          count: list.length
      });
    }

    render() {
        if( this.props.role == 'libr' ){

            //список ППС
            const list = this.state.listPps.map((pps, index) => {
                //console.log(pps);
                return (

                    <div key={pps[0]} className='one-pps'>
                        <div className='one-col c1'>{pps[0]}</div>
                        <div className='one-col c2'>{pps[1]}</div>
                        <div className='one-col c3'>{pps[2]}</div>
                        <div className='one-col c4'>{pps[3]}</div>
                        <div className='one-col c5'>{pps[4]}</div>
                        <div className='one-col c6'>{pps[5]}</div>
                        <div className='one-col c7'>{pps[6]}</div>
                        <div className='one-col c8'>{pps[7]}</div>
                        <div className='one-col c9'>{pps[8]}</div>
                        <div className='one-col c10'>{pps[9]}</div>
                        <div className='one-col c11' onClick={() => {this.editPps(pps)}}>+</div>
                    </div>
             );
            });

            return (
            <div className='librstat'>

                <Link className='link' to="/libr">Форма заполнения</Link>
                <Link className='link' to="/librstat">Статистика</Link>

                <h3>Всего заполнено: {this.state.count}</h3>
                <div className='list-stat'>{list}</div>

            </div>
            );
        } else {
            history.push('/auth');
            return ('');
        }
    }
}



// WEBPACK FOOTER //
// ./src/component/LibrStat.js